import { ChangeDetectionStrategy, Compiler, Component, Injector, OnInit } from '@angular/core';
import { EdgeServersComponent } from './edge-servers.component';

// This XXXPageComponent exists as a lazy-loading mechanism for a page's module while we
// are in MPA structure and cannot therefore use Angular's router.
@Component({
   selector: 'bb-edge-servers-page',
   template: `
      <div *ngIf="loaded">
         <!-- Once loaded, instantiate the component (start the component tree here) -->
         <ng-container *ngComponentOutlet="component"></ng-container>
      </div>
   `,
   styles: [':host { display: block; }'],
   changeDetection: ChangeDetectionStrategy.Default,
})
export class EdgeServersPageComponent implements OnInit {
   public loaded = false;
   public component: typeof EdgeServersComponent;

   constructor(
      private compiler: Compiler,
      private injector: Injector,
   ) {}

   async ngOnInit() {
      /* Statically import the page's module.
       * This import() statement will be parsed by Angular's static analysis during the build and
       * generate the module bundle. Angular inserts the module script into the HTML at runtime
       * (does not appear as a script tag in our HTML, or in the dist index.html).
       * https://angular.io/guide/lazy-loading-ngmodules
       * https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-4.html#dynamic-import-expressions
       */
      const { EdgeServersAppModule: module } = await import('./edge-servers.app.module');
      // Grab the root component of the page's component tree
      this.component = module.rootComponent;
      const factory = await this.compiler.compileModuleAsync(module);
      // Instantiate the module with the Angular injector
      factory.create(this.injector);
      this.loaded = true;
   }
}
